import type { Event } from '@patsnap/tahiti-core';

/**
 * 核稿进度状态
 */
export type ProofReadingProgressStatus = 'idle' | 'loading' | 'checking' | 'completed' | 'error';

/**
 * 核稿进度数据
 */
export interface ProofReadingProgressData {
    status: ProofReadingProgressStatus;
    currentChapterName: string;
    /**
     * 当前章节索引，使用 1 作为起始索引（显示给用户时）
     * 注意：在内部事件处理中，chapterIndex 通常从 0 开始，
     * 但在此处存储时会加 1，以便直接显示给用户
     */
    currentChapterIndex: number;
    totalChapters: number;
    /**
     * 当前处理的段落索引（从 1 开始计数）
     */
    currentParagraphIndex: number;
    /**
     * 总段落数量
     */
    totalParagraphs: number;
    totalIssuesFound: number;
    isVisible: boolean;
    autoCloseCountdown: number;
}

/**
 * 核稿进度计算属性
 */
export interface ProofReadingProgressComputed {
    progressText: string;
    showStopButton: boolean;
    showAutoCloseCountdown: boolean;
    progressPercentage: number;
}

/**
 * 核稿进度服务接口
 */
export interface ProofReadingProgressService {
    /**
     * 获取当前进度数据
     */
    getProgressData(): ProofReadingProgressData;

    /**
     * 获取计算属性
     */
    getComputedValues(): ProofReadingProgressComputed;

    /**
     * 停止核稿流程
     */
    stop(): void;

    /**
     * 隐藏进度组件
     */
    hide(): void;

    /**
     * 初始化服务（订阅编排服务事件）
     */
    initialize(): void;

    /**
     * 销毁服务
     */
    dispose(): void;

    /**
     * 进度数据变化事件
     */
    readonly onProgressDataChange: Event<ProofReadingProgressData>;

    /**
     * 计算属性变化事件
     */
    readonly onComputedValuesChange: Event<ProofReadingProgressComputed>;
}

export const ProofReadingProgressService = Symbol.for('ProofReadingProgressService');
